/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshSessionRequest} from '@cash-web/protos/squareup/franklin/app/session.pb'
import {RefreshSessionResponse} from '@cash-web/protos/squareup/franklin/app/session.pb'


export const refreshSession = (request: RefreshSessionRequest, options?: CashRequestOptions) => post<RefreshSessionRequest, RefreshSessionResponse>("/2.0/cash/refresh-session", request, {...options, rejectOnError: true })